import {
  Button,
  Dropdown,
  InputGroup,
  InputGroupPrepend,
  InputGroupText,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  PageLoader,
  TextInput
} from '@met/react-components';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { adminActions, locationActions } from '../../store';

const AddAdyenTerminalModal = ({ isOpen, onClose, onCreated, currentLocationId }) => {
  const dispatch = useDispatch();
  const locations = useSelector(state => state.admin.adminLocations.data);
  const isLoadingLocations = useSelector(state => state.admin.adminLocations.isLoading);
  const isErrorLoadingLocations = useSelector(state => state.admin.adminLocations.isError);
  const isLoading = useSelector(state => state.locations.createDevice.isLoading);
  const [locationId, setLocationId] = useState(currentLocationId || '');
  const [terminalId, setTerminalId] = useState('');
  const [terminalName, setTerminalName] = useState('');

  useEffect(() => {
    if (isOpen) {
      setLocationId(currentLocationId || '');
      dispatch(adminActions.listAdminLocations()).catch(() => {
        toastr.error('Error: Locations', 'Could not load locations.');
      });
    }
  }, [currentLocationId, dispatch, isOpen]);

  const reset = () => {
    setLocationId('');
    setTerminalId('');
    setTerminalName('');
  };

  const handleClose = () => {
    reset();
    onClose();
  };

  const handleSave = () => {
    const values = {
      locationId: locationId.trim(),
      terminalId: terminalId.trim(),
      terminalName: terminalName.trim()
    };

    if (!values.locationId || !values.terminalId || !values.terminalName) {
      toastr.error('Validation error', 'Location, Terminal ID, and Terminal Name are required.');
      return;
    }

    dispatch(locationActions.createDevice(values))
      .then(response => {
        reset();
        onCreated({
          locationId: values.locationId,
          accessCode: response?.data?.accessCode
        });
      })
      .catch(() => toastr.error('Error: Add terminal', 'Could not create terminal.'));
  };

  const locationOptions = (locations || []).map(location => ({
    label: location.locationId,
    value: location.locationId
  }));

  return (
    <Modal hidden={!isOpen}>
      <ModalContent>
        <ModalHeader>Add terminal</ModalHeader>
        <ModalBody>
          {isLoadingLocations
            ? <PageLoader />
            : isErrorLoadingLocations
              ? <p role='alert'>Could not load locations. Close and reopen this dialog to retry.</p>
              : !locationOptions.length
                ? <p>No locations are available.</p>
                : <>
                  <InputGroup>
                    <InputGroupPrepend><InputGroupText>Location ID</InputGroupText></InputGroupPrepend>
                    <Dropdown
                      options={locationOptions}
                      getOptionValue={option => option.value}
                      getOptionLabel={option => option.label}
                      value={locationId}
                      onChange={option => setLocationId(option?.value || '')}
                    />
                  </InputGroup>
                  <InputGroup>
                    <InputGroupPrepend><InputGroupText>Terminal ID</InputGroupText></InputGroupPrepend>
                    <TextInput
                      value={terminalId}
                      maxLength={100}
                      onChange={event => setTerminalId(event.target.value)}
                    />
                  </InputGroup>
                  <InputGroup>
                    <InputGroupPrepend><InputGroupText>Terminal name</InputGroupText></InputGroupPrepend>
                    <TextInput
                      value={terminalName}
                      maxLength={100}
                      onChange={event => setTerminalName(event.target.value)}
                    />
                  </InputGroup>
                </>}
        </ModalBody>
        <ModalFooter>
          <Button
            primary
            loading={isLoading}
            disabled={isLoadingLocations || isErrorLoadingLocations || !locationOptions.length}
            onClick={handleSave}
          >Save</Button>
          <Button secondary loading={isLoading} onClick={handleClose}>Cancel</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AddAdyenTerminalModal;